import React from 'react'
import { Link } from 'react-router-dom'

const LinkButton = props => (
  <Link
    className={props.addClass ? props.addClass : 'link'}
    to={props.sendTo}
  >
    {props.text}
  </Link>
)

export default LinkButton
